import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { buildOAuthState } from '../../../constants/oauth'
import AuthLayout from '../common/AuthLayout'
import SignUpSegmentSelector from '../common/SignUpSegmentSelector'

// Coach-invited golfers skip the usual segment chooser, so we ask here and pass the answer to the IdP in `state`, which it echoes back.
const AcceptInvitePage = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const next = searchParams.get('next')

  // `next` comes from an email, so without this check we would be an open redirect.
  const idpUrl = () => {
    try {
      const url = new URL(next)
      const allowedOrigin = new URL(process.env.REACT_APP_OAUTH_PROVIDER_HOST).origin

      return url.origin === allowedOrigin ? url : null
    } catch {
      return null
    }
  }

  const handleSelect = (segment) => {
    const url = idpUrl()
    if (!url) { return }

    url.searchParams.set('state', buildOAuthState(segment))
    window.location.href = url.toString()
  }

  if (!idpUrl()) {
    return (
      <AuthLayout>
        <p className='text-white text-center mt-4'>{t('auth.acceptInvite.invalidLink')}</p>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout selectorMode>
      <SignUpSegmentSelector
        onIndividualClick={() => handleSelect('individual')}
        onFamilyClick={() => handleSelect('family')}
        heading={t('auth.acceptInvite.heading')}
        showCoachOption={false}
      />
    </AuthLayout>
  )
}

export default AcceptInvitePage
